import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/cookies')({
  loader: () =>
    loadPageData({
      data: { kind: 'legal', locale: 'en', params: { legalKind: 'cookies' } },
    }),
  head: () => staticRouteHead('cookies', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <LegalPage kind="cookies" />
    </CatalogProvider>
  )
}
